import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { connect } from 'react-redux'

import { getI18n } from 'client/i18n'
import styles from './empty_hub.less'

import PayPalPage from 'components/common/paypal_page'

import Separator from 'components/common/separator'
import FadeOutLink from 'components/common/fade_out_link'
import LearnMore from 'components/common/learn_more'

const i18n = getI18n('components/pages/hub/empty_hub')

class EmptyHub extends React.Component {
  static propTypes = {
    campaigns: PropTypes.array,
    styles: PropTypes.object,
    dispatch: PropTypes.func,
    isMobile: PropTypes.bool,
  }

  state = { cardIndex: 0 }

  handleSwipeCallback = cardIndex => {
    this.setState({ cardIndex })
  }

  render() {
    return (
      <PayPalPage>
        <div styleName="container">
          <svg width="0" height="0">
            <defs>
              <linearGradient
                x1="100%"
                y1="100%"
                x2="0%"
                y2="0%"
                id="cta_gradient"
              >
                <stop stopColor="#009CDE" offset="0%" />
                <stop stopColor="#00CF92" offset="100%" />
              </linearGradient>
            </defs>
          </svg>

          <div styleName="top-area">
            <div styleName="top-left-part">
              <div styleName="title">{i18n('title')}</div>
              <div styleName="subtitle">{i18n('subtitle')}</div>
              <div className="hidden-xs">
                <LearnMore showArrow={true} />
              </div>
            </div>
            <div styleName="top-right-part" className="hidden-xs">
              <FadeOutLink
                href={`${GLOBAL_CONSTS.REQUEST_URI}/c/create`}
                className="vx_btn vx_btn-medium"
                styleName="cta-button-top"
                data-pa-click="create"
                data-nemo="create-pool-button"
              >
                {i18n('cta_button')}
              </FadeOutLink>
            </div>
          </div>

          <div className="hidden-xs">
            <div style={{ clear: 'both' }} />
            <Separator type="dotted" />
          </div>
          <div className="visible-xs-block">
            <FadeOutLink
              href={`${GLOBAL_CONSTS.REQUEST_URI}/c/create`}
              className="vx_btn vx_btn-large"
              styleName="cta-button"
              data-pa-click="create"
              data-nemo="mweb-create-pool-button"
            >
              {i18n('cta_button')}
            </FadeOutLink>

            <div styleName="learn-more-container">
              <LearnMore />
            </div>
          </div>
        </div>
      </PayPalPage>
    )
  }
}

export default connect(state => ({ isMobile: state.device_info.isMobile }))(
  cssModules(EmptyHub, styles, { allowMultiple: true })
)
